import React from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { DistroList } from '../../types';

interface DistroViewModalProps {
  active: boolean;
  onClose: () => void;
  distro: DistroList | null;
}

const DistroViewModal: React.FC<DistroViewModalProps> = ({ active, onClose, distro }) => {
  if (!distro) return null;

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-narrow">
        <div className="modal-header">
          <h2>{distro.name} — Emails</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div style={{ padding: '1rem 1.5rem' }}>
          {!distro.emails?.length ? (
            <p style={{ color: 'var(--text-dim)' }}>No emails in this list.</p>
          ) : (
            <table className="view-subtable">
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {distro.emails.map((e, i) => (
                  <tr key={i}>
                    <td>{e.first_name}</td>
                    <td>{e.last_name}</td>
                    <td>{e.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default DistroViewModal;
